import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const SuggestWhiteboardOnPageTitle: LoadableType<{
	spaceKey: string;
	contentId: string;
	title?: string | null;
	titleAfterBlur: string | null;
	isLivePage: boolean;
	isUnpublishedDraft: boolean;
	version?: number;
	hasTitleChangedRef?: React.MutableRefObject<boolean>;
}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumTrialDigestDataModal" */ './SuggestWhiteboardOnPageTitleEligibility.tsx'
			)
		).SuggestWhiteboardOnPageTitleErrorBoundary,
});
